import { render, staticRenderFns } from "./Formulas.vue?vue&type=template&id=23845e8d&"
import script from "./Formulas.vue?vue&type=script&lang=js&"
export * from "./Formulas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports